import React from "react";

interface QuoteProps {
  className?: string;
}

const Quote: React.FC<QuoteProps> = ({ className }) => {
  return (
    <svg
      className={className}
      width="62"
      height="49"
      viewBox="0 0 62 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M27.386 0.200001V8.47217L25.0877 8.93011L25.0876 8.93013C20.8305 9.78094 17.8386 11.4752 16.242 13.9926L16.2407 13.9948C15.4273 15.3135 14.9648 16.8184 14.8973 18.3663L14.8882 18.575H15.0971L24.5235 18.575C25.2827 18.575 26.0108 18.8766 26.5476 19.4134C27.0844 19.9502 27.386 20.6783 27.386 21.4375L27.386 42.875C27.386 46.1425 24.7285 48.8 21.461 48.8H3.08598C2.3268 48.8 1.5987 48.4984 1.06188 47.9616C0.525059 47.4248 0.22348 46.6967 0.22348 45.9375L0.22348 21.4375V21.4177L0.221066 21.4056C0.220837 21.4033 0.220356 21.3983 0.219669 21.3898C0.218346 21.3734 0.21664 21.3493 0.214775 21.3176C0.211048 21.2543 0.206768 21.1622 0.203629 21.0435C0.197353 20.8063 0.195683 20.464 0.21209 20.0355C0.244907 19.1785 0.350018 17.9781 0.634773 16.586C1.20445 13.801 2.49138 10.2565 5.34917 7.15486C9.59623 2.55061 16.0363 0.200001 24.5235 0.200001H27.386ZM61.0949 0.200001V8.47217L58.7967 8.93011L58.7965 8.93013C54.5394 9.78094 51.5476 11.4752 49.9509 13.9926L49.9496 13.9948C49.1362 15.3135 48.6738 16.8184 48.6062 18.3663L48.5971 18.575H48.806H58.2324C58.9916 18.575 59.7197 18.8766 60.2565 19.4134C60.7933 19.9502 61.0949 20.6783 61.0949 21.4375L61.0949 42.875C61.0949 46.1425 58.4374 48.8 55.1699 48.8H36.7949C36.0357 48.8 35.3076 48.4984 34.7708 47.9616C34.234 47.4248 33.9324 46.6967 33.9324 45.9375V21.4375V21.4177L33.93 21.4056C33.9298 21.4033 33.9293 21.3983 33.9286 21.3897C33.9273 21.3733 33.9256 21.3492 33.9237 21.3175C33.9199 21.2542 33.9156 21.1621 33.9124 21.0435C33.9061 20.8063 33.9043 20.4639 33.9206 20.0355C33.9532 19.1784 34.058 17.9781 34.3426 16.586C34.9119 13.801 36.1988 10.2565 39.0581 7.15486C43.3052 2.55061 49.7452 0.200001 58.2324 0.200001H61.0949Z"
        fill="#288F90"
        stroke="#288F90"
        strokeWidth="0.4"
      />
    </svg>
  );
};

export default Quote;
